/**
 * Stable numeric IDs for dashboard AI chat contexts, addressable as
 * `/osmosisAI?dashboard=N`. IDs are permanent: new contexts append, existing
 * values are never reassigned.
 */
export enum DashboardContextId {
  Default = 1,
  StudyPlan = 2,
  QuizWatched = 3,
  TutorWatched = 4,
  PracticeQuestion = 5,
  MissedQuestions = 6,
  LearnNode = 7,
}

export type DashboardPromptId = Exclude<
  DashboardContextId,
  DashboardContextId.Default | DashboardContextId.LearnNode
>;

const CONTEXT_IDS = Object.values(DashboardContextId).filter(
  (value): value is DashboardContextId => typeof value === 'number',
);

/** Narrows unvalidated input (e.g. a query param) to a known context ID. */
export const isDashboardContextId = (
  value: unknown,
): value is DashboardContextId =>
  typeof value === 'number' && CONTEXT_IDS.includes(value);
